'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Anchor = require('./Anchor');

var _Anchor2 = _interopRequireDefault(_Anchor);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SkipToContent = function SkipToContent(_ref) {
    var skipToContentAnchors = _ref.skipToContentAnchors;
    var theme = _ref.theme;

    if (!skipToContentAnchors.length) {
        return null;
    }
    var key = void 0;
    var anchors = skipToContentAnchors.map(function (anchor, index) {
        key = index + anchor.href;

        return _react2.default.createElement(_Anchor2.default, {
            key: key,
            href: anchor.href,
            anchorText: anchor.anchorText,
            theme: theme
        });
    });

    return _react2.default.createElement(
        'div',
        { className: theme.skip },
        anchors
    );
};

SkipToContent.defaultProps = {
    skipToContentAnchors: [],
    theme: {}
};

SkipToContent.propTypes = {
    skipToContentAnchors: _propTypes2.default.arrayOf(_propTypes2.default.shape({
        href: _propTypes2.default.string,
        anchorText: _propTypes2.default.string
    }).isRequired),
    theme: _propTypes2.default.shape({
        skip: _propTypes2.default.string,
        visuallyhidden: _propTypes2.default.string
    })
};

exports.default = SkipToContent;
//# sourceMappingURL=SkipToContent.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/ui-skip-to-content/lib/cjs/SkipToContent.js
 ** module id = 669
 ** module chunks = 1
 **/